<template>
  <div class="bg-background">
    <main class="w-full">
      <!-- Sem menu lateral: página para embed (iframe) -->
      <div class="w-full p-3 sm:p-4">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'EmbedLayout',
  created() {
    // Carrega dados iniciais ao entrar no embed (API externa)
    this.$store.dispatch('kpis/fetchAll')
  },
}
</script>

